import { render, staticRenderFns } from "./Leaves.vue?vue&type=template&id=ccdaf8a0&scoped=true"
import script from "./Leaves.vue?vue&type=script&lang=js"
export * from "./Leaves.vue?vue&type=script&lang=js"
import style0 from "./Leaves.vue?vue&type=style&index=0&id=ccdaf8a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdaf8a0",
  null
  
)

export default component.exports